import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import {
  DashboardWidgetConfig,
  DashboardWidgetMeta,
} from '../../../models/dashboard-layout.model';

@Component({
  selector: 'app-dashboard-widget-shell',
  templateUrl: './dashboard-widget-shell.component.html',
  styleUrls: ['./dashboard-widget-shell.component.css'],
})
export class DashboardWidgetShellComponent implements OnChanges {
  @Input() widget: DashboardWidgetConfig;
  @Input() meta: DashboardWidgetMeta;
  @Input() editMode = false;
  @Input() showChrome = true;
  /** When false, header is shown only while layout edit mode is active. */
  @Input() chromeInViewMode = true;

  @Output() colSpanChange = new EventEmitter<4 | 6 | 8 | 12>();
  @Output() visibleChange = new EventEmitter<boolean>();
  @Output() collapsedToggle = new EventEmitter<void>();

  colSpanOptions: Array<4 | 6 | 8 | 12> = [12];

  ngOnChanges(): void {
    if (this.meta?.allowedColSpans?.length) {
      this.colSpanOptions = [...this.meta.allowedColSpans];
    }
  }

  onColSpanSelect(value: string): void {
    const span = Number(value) as 4 | 6 | 8 | 12;
    if (this.colSpanOptions.includes(span)) {
      this.colSpanChange.emit(span);
    }
  }

  onVisibilityChange(event: Event): void {
    const checked = (event.target as HTMLInputElement).checked;
    this.visibleChange.emit(checked);
  }
}
